export default __webpack_public_path__ + "static/media/sagittal-square.c433476e.png";